import { Autocomplete, TextField, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";
import { IParentStudentItem, setCurrentEtab, setStudents, setdataFiltered } from "../../store/focusEcoleSlice";


export interface ISearchBarByEtabProps {
  localStudentDatasFiltered: IParentStudentItem[];
  setLocalStudentDatasFiltered: (x: IParentStudentItem[]) => void;
}

const SearchBarByEtab = (props: ISearchBarByEtabProps) => {

  const { localStudentDatasFiltered, setLocalStudentDatasFiltered } = props

  const dispatch = useDispatch();
  const { students, etabs, currentEtab } = useSelector((state: IReduxState) => state.focusEcole);
  console.log("🚀 ~ SearchBarByEtab ~ currentEtab++++:", currentEtab)
  console.log("🚀 ~ SearchBarByEtab ~ etabs:", etabs)

  //hooks
  const theme = useTheme();


  return (
    <Box>
      <Autocomplete
        fullWidth
        // onChange={(e: any, etab: any) => {
        //   if (etab) {
        //     dispatch(setCurrentEtab({
        //       ...etabs,
        //       codeEtab: etab.codeEtab
        //     }));
        //   }
        //   else {
        //     dispatch(setCurrentEtab({}))
        //     dispatch(setdataFiltered([...students]))
        //     setLocalStudentDatasFiltered([...localStudentDatasFiltered])
        //   }
        // }}

        onChange={(e: any, etab: any) => {
          if (etab) {
            dispatch(setCurrentEtab({
              ...currentEtab,
              codeEtab: etab.codeEtab
            }));
        
            // Filtrer les étudiants selon l'établissement sélectionné
            const filteredStudents = students.filter(student => student.codeEtab === etab.codeEtab);
            
            dispatch(setdataFiltered(filteredStudents));
            setLocalStudentDatasFiltered(filteredStudents);

            console.log("Établissement sélectionné++++++:", etab);
            console.log("Étudiants filtrés--------:", filteredStudents);
          
          } else {
            dispatch(setCurrentEtab({}));
            dispatch(setdataFiltered(students));
            setLocalStudentDatasFiltered(students);
          }
        }}
        
        options={etabs}
        renderOption={(props, etab) => {
          const { libEtab, codeEtab } = etab;
          const newIndex = etabs.findIndex((item: any) => item.libEtab === libEtab)
          return (
            <span {...props}
              style={{ backgroundColor: (newIndex % 2 === 0) ? "aliceblue" : "", fontSize: 13 }}
            >
              {libEtab}
            </span>
          );
        }}

        getOptionLabel={(etab) =>
          `${etab.libEtab}`
        }

        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            fullWidth
            size="small"
            label="Choisir un établissement"
          />
        )}
      />
    </Box>
  );
};
export default SearchBarByEtab;
